import { render, staticRenderFns } from "./TraffictViolation.vue?vue&type=template&id=57892458&scoped=true"
import script from "./TraffictViolation.vue?vue&type=script&lang=js"
export * from "./TraffictViolation.vue?vue&type=script&lang=js"
import style0 from "./TraffictViolation.vue?vue&type=style&index=0&id=57892458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57892458",
  null
  
)

export default component.exports